const elementsToQueryDefault =
  "a:not([hidden]), button, input, textarea, select, details,[tabindex]:not([tabindex='-1'])";

export const getKeyboardFocusableElements = (
  element: HTMLElement | null,
  elementsToQuery: string = elementsToQueryDefault,
) => {
  if (element) {
    const elements: NodeListOf<HTMLElement> = element.querySelectorAll(elementsToQuery);

    return Array.from(elements).filter((el) => !el.hasAttribute('disabled'));
  }
  return [];
};

export const userHasAskedToReduceMotion =
  window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
